import React from 'react';
import classNames from 'classnames';
import { Divider } from '../../../ui';
import { ReplyStateSwitch } from './reply-state-switch';
import { LoadMoreStateSwitch } from './load-more-state-switch';
import { LOAD_MORE_REPLIES_OLDER, LOAD_MORE_REPLIES_NEWER, REPLY_LIST, LOAD_MORE_REPLIES, SHOW_LIVE_REPLIES_ROOT, SHOW_LIVE_REPLIES_END, WITH_LIVE, } from '../../../common/constants/data-hooks';
import { unreachable } from '../../../ts-utils';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../context/api-context/use-api';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { ShowLiveComments, LoadMoreLive, LiveCommentIndicator } from '../live-updates-components';
import { isMarkable } from '../../../common/store/comments/mark/mark-types';
import { getMarkedState } from '../../../common/store/comments/mark/mark-selectors';
import ReactionConfigProvider from '../../context/configuration-context/reaction-config/reaction-config-provider';
import styles from './reply-list.module.scss';
const ReplyList = ({ fetchNextReplies, fetchPrevReplies, state, id, memberState, interactionFetchState }) => {
    const { resourceId, reactions } = useConfiguration();
    const reactionsConfig = reactions && reactions.replyReactions;
    const t = useTranslate();
    const { revealLiveReplies, isMobile } = useApi((state, actions) => ({
        revealLiveReplies: actions.revealLiveReplies,
        isMobile: getIsMobile(state),
    }));
    switch (state.type) {
        case 'EMPTY': {
            // This empty div is little sin to help out testing
            return React.createElement("div", { "data-hook": REPLY_LIST, id: id });
        }
        case 'ONLY_VIEW_LIVE': {
            return (React.createElement("div", { "data-hook": REPLY_LIST, id: id },
                React.createElement(LoadMoreLive, { text: t('reply-list.view-replies', { count: state.count }), onClick: () => revealLiveReplies({ resourceId, parentId: state.parentCommentId }), dataHook: SHOW_LIVE_REPLIES_ROOT })));
        }
        case 'ONLY_LOAD_MORE': {
            return (React.createElement("div", { "data-hook": REPLY_LIST, id: id },
                React.createElement(LoadMoreStateSwitch, { text: t('reply-list.show-more-replies'), onClick: fetchNextReplies, state: state.next, className: classNames(styles.onlyLoadMore, isMobile && styles.isMobile), dataHook: LOAD_MORE_REPLIES })));
        }
        case 'ONLY_LOAD_MORE_AND_LIVE': {
            return (React.createElement("div", { "data-hook": REPLY_LIST, id: id },
                React.createElement(LoadMoreStateSwitch, { text: t('reply-list.show-more-replies'), onClick: fetchNextReplies, state: state.next, className: classNames(styles.onlyLoadMore, isMobile && styles.isMobile, true && styles.isLive), dataHook: classNames(LOAD_MORE_REPLIES, WITH_LIVE), icon: isMobile ? React.createElement(LiveCommentIndicator, { position: "mobile-button" }) : undefined })));
        }
        case 'FULL': {
            return (React.createElement(ReactionConfigProvider, { config: reactionsConfig },
                React.createElement("div", { "data-hook": REPLY_LIST, id: id, className: classNames(styles.root, isMobile && styles.isMobile) },
                    React.createElement(LoadMoreStateSwitch, { text: t('reply-list.show-more-replies'), onClick: fetchNextReplies, state: state.next, className: styles.loadMoreTop, dataHook: LOAD_MORE_REPLIES_OLDER }),
                    state.comments.map((replyState, index) => (React.createElement(React.Fragment, { key: 'localId' in replyState ? replyState.localId : replyState.commentId },
                        resolveDivider(index, state.comments, isMobile),
                        React.createElement(ReplyStateSwitch, { key: 'localId' in replyState ? replyState.localId : replyState.commentId, replyState: replyState, memberState: memberState, interactionFetchState: interactionFetchState })))),
                    state.live.type === 'SOME' && (React.createElement(ShowLiveComments, { onClick: () => revealLiveReplies({ resourceId, parentId: state.parentCommentId }), text: t('live-updates.show-live-replies', {
                            count: state.live.count,
                        }), position: "reply-end", dataHook: SHOW_LIVE_REPLIES_END })),
                    React.createElement(LoadMoreStateSwitch, { text: t('reply-list.show-more-replies'), onClick: fetchPrevReplies, state: state.prev, className: styles.loadMoreBottom, dataHook: LOAD_MORE_REPLIES_NEWER }))));
        }
        default:
            throw unreachable(state);
    }
};
const resolveDivider = (index, replyList, isMobile) => {
    if (index === 0) {
        return null;
    }
    const next = replyList[index];
    const prev = replyList[index - 1];
    const nextIsMarked = isMarkable(next) && getMarkedState(next.comment, next.marked).isMarked;
    const prevIsMarked = isMarkable(prev) && getMarkedState(prev.comment, prev.marked).isMarked;
    return (React.createElement(Divider, { className: classNames(styles.divider, isMobile && styles.isMobile, prevIsMarked && styles.noTopMargin, nextIsMarked && styles.noBottomMargin) }));
};
export default ReplyList;
//# sourceMappingURL=reply-list.js.map